module.exports = __webpack_public_path__ + "img/加载logo(1).7e5ee412.png";